import React, { ReactNode } from 'react';
import cn from 'classnames';

import { IGridContainerProps } from './GridContainer.types';

import './GridContainer.scss';

const GridContainer: React.FC<IGridContainerProps> = ({
	children,
	customClassName = '',
	columns = 1,
	gap = '5px 30px',
	template,
	justifyItems = 'auto',
	gridTemplateAreas,
	style = {},
	gridAutoFlow = 'column',
}) => {
	const classes = cn('f5gGridContainer', {
		[`${customClassName}`]: customClassName,
	});

	return (
		<div
			className={classes}
			data-testid='f5g-grid-container'
			style={{
				gridTemplateColumns: template || `repeat(${columns}, 1fr)`,
				gridGap: gap,
				gridTemplateAreas: gridTemplateAreas,
				justifyItems: justifyItems,
				gridAutoFlow,
				...style,
			}}
		>
			{children as ReactNode}
		</div>
	);
};

export default GridContainer;
